var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinAnglePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pin-angle-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.999,
    viewBox: "0 0 18 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13119",
    "data-name": "Group 13119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13012",
    "data-name": "Path 13012",
    d: "M14.9,2.166a.644.644,0,0,1,.456.188l6.378,6.378a.644.644,0,0,1,0,.911A2.685,2.685,0,0,1,19.8,10.4a3.6,3.6,0,0,1-.593-.05l-4.038,4.038a7.637,7.637,0,0,1,.206,1.305,3.9,3.9,0,0,1-.928,3.06.644.644,0,0,1-.911,0L9.894,15.111l-4.1,4.1c-.251.251-1.571,1.162-1.822.911s.66-1.572.911-1.822l4.1-4.1L5.339,10.555a.644.644,0,0,1,0-.911A3.9,3.9,0,0,1,8.4,8.716,7.631,7.631,0,0,1,9.7,8.922l4.038-4.037a3.572,3.572,0,0,1-.052-.594,2.686,2.686,0,0,1,.759-1.937.644.644,0,0,1,.455-.188Z",
    transform: "translate(-3.928 -2.166)",
    fill: "#600097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAnglePurple);
export default __webpack_public_path__ + "static/media/pin-angle-purple.fda8b7e48bf5412172cd4eb5552977a2.svg";
export { ForwardRef as ReactComponent };